import { useState, useEffect, useCallback } from 'react';
import { Tabs, Row, Col } from 'antd';
import StudentConfig from "@/config/student";
import TranscriptConfig from "@/config/transcript";
import SectionConfig from "@/config/section";
import { convertToTimestamp, startTimeToday, endTimeToday } from "@/lib/dateTime";
import { ClassSubjectListType, ClassType } from "@/containers/organization/classManagement/types";
import { StudentType } from "@/containers/humanResourceManagement/studentManagement/types";
import { TranscriptListType } from './types';
import Students from './Students';

const { getAllStudentByClass } = StudentConfig;
const { getTranscriptList } = TranscriptConfig;
const { getClassSubject } = SectionConfig;
const { TabPane } = Tabs;

type Props = {
  classArray: ClassType[];
  examId: number | null;
  excelTitle: string;
  year: string;
}

function Classes(props: Props) {
  const { classArray, examId, excelTitle, year } = props;
  const [selectedClassId, setSelectedClassId] = useState<string>('');
  const [studentArray, setStudentArray] = useState<StudentType[]>([]);
  const [transcriptList, setTranscriptList] = useState<TranscriptListType>({});
  const [subjectInfo, setSubjectInfo] = useState<ClassSubjectListType>({});
  const { className } = classArray?.find((item) => `${item.classId}` === selectedClassId) ?? {};
  const excelTitleWithClass = `${excelTitle}_${className}`;

  const getTranscriptListFunction = useCallback(() => {
    const params = {
      examId,
      studentIds: studentArray.map((item) => item.userAccountId),
    };

    getTranscriptList(params).then((res: any) => {
      const transcriptList = res?.value ?? {};
      setTranscriptList(transcriptList);
    });
  }, [examId, studentArray]);

  useEffect(() => {
    setSelectedClassId(`${classArray[0]?.classId ?? ''}`);
  }, [classArray]);

  useEffect(() => {
    if (selectedClassId) {
      const getClassSubjectFunction = () => {
        getClassSubject({ classId: selectedClassId }).then((res: any) => {
          const subjectInfo = res?.value ?? [];
  
          setSubjectInfo(subjectInfo);
        });
      };

      const params = {
        classId: selectedClassId,
        startTime: convertToTimestamp(startTimeToday),
        endTime: convertToTimestamp(endTimeToday),
      };

      getAllStudentByClass(params).then((res: any) => {
        const studentArray = res?.value ?? [];
        setStudentArray(studentArray);
      });
      getClassSubjectFunction();
    }
  }, [selectedClassId]);

  useEffect(() => {
    if (examId && studentArray.length > 0) {
      getTranscriptListFunction();
    }
  }, [examId, studentArray]);

  function renderClassTab() {
    return classArray.map((item: ClassType) => {
      const { classId, className } = item;

      return (
        <TabPane key={classId} tab={className}>
          {examId && Object.keys(transcriptList).length > 0 &&
            <Students
              studentArray={studentArray}
              transcriptList={transcriptList}
              examId={examId}
              getTranscriptListFunction={getTranscriptListFunction}
              excelTitleWithClass={excelTitleWithClass}
              subjectInfo={subjectInfo}
              classInfo={item}
              year={year}
            />
          }
        </TabPane >
      );
    });
  };

  return (
    <Row>
      <Col span={24}>
        <Tabs
          size="large"
          tabPosition="left"
          onChange={setSelectedClassId}
          activeKey={selectedClassId}
          destroyInactiveTabPane
        >
          {renderClassTab()}
        </Tabs>
      </Col>
    </Row>
  )
}

export default Classes;